import { makeApi } from "@zodios/core";
import { z } from "zod";

import { kiliDataTableSearchRequestBody } from "@/types/kili/kili-data-table-definition";
import { kiliSitesDataTableSchema } from "@/types/kili/sites/kili-site-search.type";

export const kiliSitesApi = makeApi([
  {
    method: "post",
    path: "/search",
    response: z.any(),
    alias: "searchSites",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: kiliDataTableSearchRequestBody(kiliSitesDataTableSchema.filterableFields).required(),
      },
    ],
  },
]);
